import React from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import EncoderView from '../components/Encoder';

export default function CreateEncoderPage() {
  const { idPaciente, tiempo5STS } = useParams();

  return (
    <DashboardLayout>
      <EncoderView idPaciente={idPaciente} tiempo5STS={tiempo5STS} />
    </DashboardLayout>
  );
}
